export const user = {
  state: {
    user: null
  },
  mutations: {
    updateUser(state, newUser) {
      state.user = newUser;
    },
    removeUser(state) {
      state.user = null;
    }
  },
  actions: {
    loginUser({ commit }, user) {
      commit("updateUser", user);
    },
    logoutUser({ commit }) {
      commit("removeUser");
    }
  },
  getters: {
    currentUser(state) {
      return state.user
    },
    authenticated(state) {
      if (state.user) {
        return true
      } else {
        return false
      }
    },
    jwToken(state, getters) {
      if (getters.currentUser) {
        return getters.currentUser.token
      }
    }
  }
}